export class BinarySearch {
    public static search<T>(arr: T[], item: T, compare: (a: T, b: T) => number): BinarySearchResult {
        let low = 0;
        let high = arr.length - 1;
        let insertIndex = arr.length;

        while (low <= high) {
            const mid = Math.floor((low + high) / 2);
            const cmp = compare(item, arr[mid]);

            if (cmp === 0) {
                return { foundIndex: mid, insertIndex: mid };
            } else if (cmp < 0) {
                insertIndex = mid;
                high = mid - 1;
            } else {
                low = mid + 1;
            }
        }
        return { foundIndex: -1, insertIndex: low };
    }
}

export interface BinarySearchResult {
    foundIndex: number;
    insertIndex: number;
}
